<template>
  <div id="means" :class="$mq" :style="{ minHeight: this.$store.getters.fullWindowHeightMinusFooter }">

    <section :class="{ adjust: sizeOfWrapper }">
      <div class="wrapper py-4">
        <p class="relative mb-1 font-6-5 txt-bold txt-upper" style="top: -1px;">Keinot:</p>

        <!-- ohje-boksi -->
        <div v-if="!isCategory" class="card mb-4"> <!-- nyt toimii ainonastaan jos isCategory ei ole null (=kaikki kategoriat nnäkyvissä) -> muuta! -->
          <!-- <div @click="tipsAndTricks = !tipsAndTricks" class="py-2 flex align-center pointer">
            <p class="flex-1 font-8 color-grey">teoria: <span class="font-10 color-black">Keinot ja keinokategoriat</span></p>
            <i v-if="!tipsAndTricks" class="material-icons font-10">expand_more</i>
            <i v-else class="material-icons font-10">expand_less</i>
          </div> -->
          <!-- <div v-show="tipsAndTricks" class="tipsntricks pt-2 pb-4"> -->
          <div class="tipsntricks">
            <div class="flex flex-center">
              <!-- <img src="/images/means_categories.svg" alt=""> -->
            </div>
            <div class="font-8">Keinot jakautuvat <span class="txt-bold">tila-</span> ja <span class="txt-bold">taustatekijät-</span>pääluokkiin ja edelleen eri kategorioihin.</div>

            <!-- <span class="txt-bold"></span> -->

          </div>
        </div>
        <div v-if="isCategory" class="card mb-4"> <!-- nyt toimii ainonastaan jos isCategory ei ole null (=kaikki kategoriat nnäkyvissä) -> muuta! -->
          <!-- <div @click="tipsAndTricks = !tipsAndTricks" class="py-2 flex align-center pointer">
            <p class="flex-1 font-8 color-grey">teoria: <span class="font-10 color-black">{{ this.isCategory.title }}</span></p>
            <i v-if="!tipsAndTricks" class="material-icons font-10">expand_more</i>
            <i v-else class="material-icons font-10">expand_less</i>
          </div> -->
          <!-- <div v-show="tipsAndTricks" class="pt-2 pb-4"> --> <!-- liitä asianmukainen kontentti -->
          <div>
            <div v-if="isCategory.class === 'A'" class="font-8-5"><span class="txt-bold">Rungon tilallinen potentiaali</span> mahdollistaa laajoja, mutta harvoin toteutettavissa olevia muutoksia.</div>
            <div v-if="isCategory.class === 'B'" class="font-8-5"><span class="txt-bold">Joustavuuskonseptit</span> tarjoavat mahdollisuuksia mukauttaa tiloja muuttuviin tarpeisiin rakennuksen normaalin käytön aikana.</div>
            <div v-if="isCategory.class === 'C'" class="font-8-5"><span class="txt-bold">Jaettujen tilojen</span> avulla asukkaat voivat saada asumisen aikana vaihtelevasti käyttöönsä tiloja, jotka soveltuvat erilaisiin erityistarpeisiin ja toisinaan myös asumisen perustoimintoihin.</div>
            <div v-if="isCategory.class === 'D'" class="font-8-5">Tässä esitetään <span class="txt-bold">hallintamuotoja ja sopimusperusteita</span>, jotka helpottavat monipuolisen tilaohjelman toteuttamista rakennukseen tai kortteliin, tuottavat asumista auttavia palveluja tai tukevat asukkaan osallisuutta vähentämällä asumisen kustannuksia.</div>
            <div v-if="isCategory.class === 'E'" class="font-8-5">Seuraavat <span class="txt-bold">toteutus- ja prosessimallit</span> tukevat asukkaan osallisuutta ja tuottavat siten ketteryyttä.</div>
            <div v-if="isCategory.class === 'F'" class="font-8-5">Tässä esitetyt <span class="txt-bold">taloudelliset järjestelyt</span> helpottavat rakentamisvaiheen pääomahankintaa tai vähentävät asukkaan asumiskustannuksia.</div>
            <div v-if="isCategory.class === 'G'" class="font-8-5">Nämä <span class="txt-bold">palvelut</span> auttavat ja tukevat asukkaita asumisessa.</div>
            <div v-if="isCategory.class === 'H'" class="font-8-5">Seuraavat <span class="txt-bold">sovellukset</span> parantavat tai tukevat jaettujen tilojen käyttömahdollisuuksia.</div>
          </div>
        </div>

        <!-- galleria -->
        <Gallery>
          <GitemMeans
            v-for="(mean, index) in setOfMeans"
            :key="index"
            :data="mean"
          >
          </GitemMeans>
        </Gallery>
      </div>
    </section>

    <menuMeans/>

  </div>
</template>

<script>
// import db from '@/firebase/init'
import { mapState } from 'vuex'
import menuMeans from '@/components/menuMeans'
import Gallery from '../components/Gallery.vue'
import GitemMeans from '../components/GitemMeans.vue'

export default {
  name: 'means',

  components: {
    menuMeans,
    Gallery,
    GitemMeans
  },

  data () {
    return {
      tipsAndTricks: false
    }
  },

  created () {
    this.$store.dispatch('storeMeans')
    this.$store.dispatch('storeExamples')
  },

  computed: {
    ...mapState([
      'isCategory',
      'isCategoryMenu'
      // 'vuexMeans'
    ]),

    setOfMeans () {
      let newSet = this.$store.state.means.map(a => a)
      if (this.isCategory) {
        return newSet.filter(mean => {
          return mean.ref === this.isCategory.class
        })
      } else {
        // siirtää rtp:n arrayn ensimmäiseksi
        let first = newSet.find(mean => {
          return mean.ref === 'A'
        })
        newSet.sort((x, y) => {
          return x === first ? -1 : y === first ? 1 : 0
        })
        return newSet
      }
    },

    sizeOfWrapper () {
      if (this.isCategoryMenu === true) {
        return false
      } else {
        return true
      }
    }
  }
}
</script>

<style lang="scss">
@import "@/styles/styles.scss";

#means {
  section {
    position: relative;
    top: 0;
    left: $category-menu-width;
    width: calc(100% - #{$category-menu-width});
    &.adjust {
      left: 0;
      width: 100%;
    }
  }
  &.tablet section, &.others section {
      left: $category-menu-width-extended;
      width: calc(100% - #{$category-menu-width-extended});
    }
}

.tipsntricks {
  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-rows: 1fr;
  .phone &, .tablet & {
    grid-template-columns: 1fr;
    grid-template-rows: auto 1fr;
  }
  img {
    width: 100%;
    width: 200px;

  }
}
</style>
